module.exports = __webpack_public_path__ + "img/DigitalCalendar2.0d4699d4.jpg";